import { type FC } from 'react'
import { type UseFormReturn } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import { Heading } from 'base-ui'

import { type MarketplacePartnerRegisterPageFormV3Values } from '../../../hooks/marketplacePartnerRegisterPageFormV3RHFModel'
import { useMarketplacePartnerRegisterPageFormV3Categories } from '../../../hooks/useMarketplacePartnerRegisterPageFormV3Categories'
import { type MarketplacePartnerRegisterPageDictionaryOption } from '../../../hooks/useMarketplacePartnerRegisterPageGetDictionaryOptionsByName'

import { MarketplacePartnerRegisterPageFormV3CategoriesSelection } from './MarketplacePartnerRegisterPageFormV3CategoriesSelection'
import { MarketplacePartnerRegisterPageFormV3TargetCountries } from './MarketplacePartnerRegisterPageFormV3TargetCountries'

type MarketplacePartnerRegisterPageFormV3CategoriesProps = {
  categoriesOptions?: MarketplacePartnerRegisterPageDictionaryOption[]
  form: UseFormReturn<MarketplacePartnerRegisterPageFormV3Values>
  targetCountriesOptions?: MarketplacePartnerRegisterPageDictionaryOption[]
}

export const MarketplacePartnerRegisterPageFormV3Categories: FC<
  MarketplacePartnerRegisterPageFormV3CategoriesProps
> = ({ categoriesOptions, form, targetCountriesOptions }) => {
  const {
    categoriesSelectionEntries,
    handleCheck,
    moveCategories,
    toggleTargetCountry,
    watchedTargetCountries,
  } = useMarketplacePartnerRegisterPageFormV3Categories({
    categoriesOptions,
    form,
  })

  return (
    <div className="flex flex-col gap-10">
      <Heading level={2} size="l">
        <FormattedMessage id="marketplacePartnerRegisterPage.categories.title" />
      </Heading>
      <div className="text-m">
        <FormattedMessage id="marketplacePartnerRegisterPage.categories.description" />
      </div>
      <MarketplacePartnerRegisterPageFormV3CategoriesSelection
        entries={categoriesSelectionEntries}
        form={form}
        moveCategories={moveCategories}
        onCheck={handleCheck}
      />
      <MarketplacePartnerRegisterPageFormV3TargetCountries
        form={form}
        targetCountriesOptions={targetCountriesOptions ?? []}
        targetCountryValues={watchedTargetCountries}
        toggleTargetCountry={toggleTargetCountry}
      />
    </div>
  )
}
